<template>
  <div>
    <div class="datepicker-device-overview" v-if="dev_fid">
      <div class="w200">
        <div class="filter checkbox" v-if="$store.getters.getPermissions?.permissionGod === true">
          <div class="info">
            {{ translate('gps_track.auto_update') }}
          </div>
          <label class="switch" @click.prevent="auto_update = !auto_update">
            <input type="checkbox" v-model="auto_update">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="datepicker-trigger">
        <router-link
            class="add_btn arrow"
            :to="'/device/' + $route.params.device_id + '/tracking?&ts_start='+date[0]+'&ts_end='+date[1]"
            v-if="$store.getters.getPermissions?.viewDeviceTracking === true"
            title="Tracking"
        >
          <span class="mdi mdi-map" />
        </router-link>

        <button class="arrow mdi mdi-arrow-left" @click="subDay"/>

        <div class="overview_datepicker">
          <div class="flex-item datetime">
            <span class="form-group">
              <WrapDatePicker
                v-model="date"
                type="datetime"
                :range="true"
                value_type="X"
                :confirm="true"
                :clearable="false"
                :placeholder="translate('gps_track.date_range')"
              />
            </span>
          </div>
        </div>

        <button class="arrow mdi mdi-arrow-right" @click="addDay"/>

        <button
            class="add_btn arrow mdi mdi-calendar-today"
            @click="today"
            v-if="$store.getters.getPermissions?.permissionGod === true"
            title="Today"
        />

        <button
            class="add_btn arrow mdi mdi-clock-time-one-outline"
            @click="last_hour"
            v-if="$store.getters.getPermissions?.permissionGod === true"
            title="Last Hour"
        />
      </div>

      <div class="w200">
        <span
            v-if="show_button"
            class="last_day_online"
            @click="get_last_day_online()"
        >
          {{ translate("last_day_online") }}
        </span>
      </div>

    </div>

    <div class="charts" v-if="!no_data">
      <div class="chart">
        <SimcardStatusChart
          :main_data="simcard_status"
          :dev_fid="dev_fid"
          :show_content="show.simcard_status"
          @show_simcard_status="show_simcard_status"
          :today="false"
        />
      </div>

      <div class="chart" v-if="!hide_traffic">
        <SpeedChart
            :params="params_for_req"
            :show_block="show.speed"
            @show_speed="show_speed"
            :today="false"
        />
      </div>

      <div class="chart">
        <RssiChart
          :params="params_for_req"
          :show_block="show.rssi"
          @show_rssi="show_rssi"
          :today="false"
        />
      </div>

      <div class="chart" v-if="$store.getters.getPermissions.viewDeviceIfaceStatus === true">
        <IFacesChart
            :params="params_for_req"
            :show_block="show.ifaces"
            @show_ifaces="show_ifaces"
            :today="false"
        />
      </div>

      <div class="chart">
        <TemperChart
          :params="params_for_req"
          :show_block="show.temper"
          @show_temper="show_temper"
          :today="false"
        />
      </div>

      <div class="chart" v-if="$store.getters.getPermissions.permissionGod === true">
        <CPUChart
          :params="params_for_req"
          :show_block="show.cpu"
          @show_cpu="show_cpu"
          :today="false"
        />
      </div>
    </div>

    <div v-else style="text-align: center;  vertical-align: middle;">
      <div style="height: 100%">
        <div style="height: 100%" v-if="loading && !(Object.keys(this.simcard_status).length > 0)">
          <div class="spinner" >
            <scale-loader />
          </div>
        </div>
        <h1 v-else>
          {{translate('no_data')}}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import SimcardStatusChart from './Charts/SimcardStatusChart.vue'
import RssiChart from './Charts/RssiChart.vue'
import SpeedChart from './Charts/SpeedChart.vue'
import TemperChart from './Charts/TemperChart.vue'
import CPUChart from './Charts/CPUChart.vue'
import IFacesChart from './Charts/IFacesChart.vue'
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'Statistics',
  components: {
    WrapDatePicker,
    SimcardStatusChart,
    RssiChart,
    SpeedChart,
    TemperChart,
    CPUChart,
    IFacesChart
  },
  props: ['dev_fid', 'profile'],
  data () {
    return {
      simcard_status: {},
      rssi: {},
      loading: true,

      date: [],

      timer_status: null,

      show: {
        speed: false,
        rssi: false,
        temper: false,
        ifaces: false,
        cpu: false,
        simcard_status: false
      },

      auto_update: false
    }
  },
  computed: {
    params_for_req(){
      return {
        "fid": this.dev_fid,
        "ts_start": this.date[0],
        "ts_end": this.date[1]
      }
    },
    show_button(){
      return this.last_day_online !== null && this.$store.getters.getPermissions.permissionGod === true
    },
    last_day_online(){
      if (!this.profile.status_info.online) return null

      let uptime = this.profile.status_info.online

      let today = new Date()
      today = Math.round(new Date(today.getFullYear(), today.getMonth(), today.getDate()) / 1000)

      let date = new Date((uptime.status_ts + uptime.uptime) * 1000)
      date = Math.round(new Date(date.getFullYear(), date.getMonth(), date.getDate()) / 1000)

      return date && date !== today ? date : null
    },
    hide_traffic(){
      return this.$store.getters.getSettings?.device_statistics?.hide_traffic
    },
    no_data(){
      return !(this.simcard_status.data && this.simcard_status.data.length > 0)
    },
  },
  watch: {
    auto_update(){
      if (this.auto_update){
        this.interval = setInterval(() => {
          this.date = [String(+this.date[0] + 30), String(+this.date[1] + 30)]
        }, 30*1000);
      }else{
        clearInterval(this.interval)
      }
    },
    show: {
      deep: true,
      handler(){
        let string = '?'

        for (let key in this.show) {
          string += '&' + key + '=' + this.show[key]
        }

        history.pushState(null, null, this.$route.path + string)
      }
    },
    dev_fid () {
      this.getData()
    },

    date () {
      let ts_start = +this.date[0]
      let ts_end = +this.date[1]

      this.$set(this.show, "ts_start", ts_start.toString())
      this.$set(this.show, "ts_end", ts_end.toString())

      clearTimeout(this.timeout)
      this.timeout = setTimeout( () => { this.getData() }, 1000 )
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer_status)
  },
  created () {
    this.check_query()
  },
  methods: {
    update_date(){
      let now = (Math.round(new Date() / 1000)).toString()
      let one_day_ago = (now - 86400).toString()
      this.date = [one_day_ago, now]
    },
    get_last_day_online(){
      if (this.last_day_online){
        let uptime = this.profile.status_info.online
        let hours12 = 43200 //Количество секунд в 12 часах
        let ts_start = uptime.status_ts - hours12
        let ts_end = uptime.status_ts + hours12
        this.date = [ts_start.toString(), ts_end.toString()]
      }
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case "simcard_status":
            case "rssi":
            case "speed":
            case "temper":
            case "ifaces":
            case "cpu":
              this.show[key] = this.$route.query[key] ? JSON.parse(this.$route.query[key]) : false
              break
            case "ts_start":
              this.date = [this.$route.query[key], this.date[1]]
              break
            case "ts_end":
              this.date = [this.date[0], this.$route.query[key]]
              break
          }
        }
        if (!this.date[0] && !this.date[1]){
          this.update_date()
        }
      }else{
        this.update_date()
      }
    },

    getData () {
      if (this.$route.name === 'device_section') {

        this.simcard_status = this.rssi = {}

        this.loading = true
        this.$http.v1.getDeviceStats(this.params_for_req, (response) => {
          this.simcard_status = response.data.online
          this.loading = false
        })
      }
    },
    show_ifaces(){
      this.show.ifaces = !this.show.ifaces
    },
    show_simcard_status(){
      this.show.simcard_status = !this.show.simcard_status
    },
    show_rssi(){
      this.show.rssi = !this.show.rssi
    },
    show_speed(){
      this.show.speed = !this.show.speed
    },
    show_temper(){
      this.show.temper = !this.show.temper
    },
    show_cpu(){
        this.show.cpu = !this.show.cpu
    },
    today(){
      let today = new Date()
      let date_start = new Date().setHours(0, 0, 0, 0)
      this.date = [(+date_start / 1000).toString(), Math.round(+today / 1000).toString()]
    },
    last_hour(){
      let now = Math.round(new Date() / 1000).toString()
      let hour_ago = Math.round(new Date().setHours(new Date().getHours() - 1) / 1000).toString()
      this.date = [hour_ago, now]
    },
    addDay() {
      let date = new Date(+this.date[1] * 1000)
      date.setDate(date.getDate() + 1);
      if (new Date(date) > new Date()){
        let now = (Math.round(new Date() / 1000)).toString()
        let one_day_ago = (now - 86400).toString()
        this.date = [one_day_ago, now]
      }else{
        let date_start = date.setHours(0, 0, 0)
        let date_end = date.setHours(23, 59, 59)
        this.date = [(+date_start / 1000).toString(), (+date_end / 1000).toString()]
      }
    },

    subDay() {
      let date = new Date(+this.date[1] * 1000)
      date.setDate(date.getDate() - 1);
      let date_start = date.setHours(0, 0, 0)
      let date_end = date.setHours(23, 59, 59)
      this.date = [(+date_start / 1000).toString(), (+date_end / 1000).toString()]
    }
  }
}

</script>
<style lang="scss">

  .datepicker_input {
    .mx-input {
      display: inline-block;
      border: 1px solid #CCC5B9;
      border-radius: 4px;
      text-align: center;
      min-width: 210px;
      background-color: #ffffff;
      font-size: 16px;
      max-width: 300px;
      height: 45px;
      width: 80%;
    }

    input[readonly] {
      cursor: pointer;
      color: #000000;
      background-color: #FFFFFF;
    }
  }

  .datepicker-trigger {
    padding-top: 15px;
    text-align: center;
    display: inline-flex;
    width: 100%;
    justify-content: center;
  }

  .datepicker-device-overview {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 20px;
    .w200{
      min-width: 200px;
    }
    .filter{
      margin: 0;
    }
    .last_day_online{
      border:  1px solid #CCC5B9;
      border-radius: 4px;
      height: 45px;
      font-size: 14px;
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        background-color: rgba(219, 228, 230, 0.3);
      }
    }
    .add_btn{
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-size: 20px;
        color: #333333;
      }
    }
  }

  .arrow {
    width: 45px;
    display: inline-block;
    border:  1px solid #CCC5B9;
    border-radius: 4px;
    padding: 5px 10px;
    height: 45px;
    font-size: 26px;
    background-color: #FFFFFF;
  }

  .refresh {
    width: 45px;
    display: inline-block;
    border:  1px solid #CCC5B9;
    border-radius: 4px;
    height: 45px;
    background-color: #FFFFFF;
    font-size: 2em;
  }

  .device-overview-datepicker-input {
    flex-grow: 1;
  }
  .refresh:hover,
  .arrow:hover {
    background-color: rgba(219, 228, 230, 0.3);
  }
  .overview_datepicker {
    display: flex;
    height: 45px;
    .datetime{
      .form-group {
        display: inline-block;
        width: 350px;
        .form-control{
          height: 45px;
          display: flex;
          align-items: center;
          padding: 7px;
          .mx-input-wrapper{
            width: 100%;
          }
        }
      }

    }
  }

  .charts{
    padding: 0;
    .chart{
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

  .overview {
    > *:not(:first-child) {
      margin-top: 7px;
    }
  }

  @media (max-width:550px){
    .overview_datepicker {
      flex-direction: column;
      .period{
        min-width: 210px;
      }
    }
  }

</style>
